'use client'

import { useEffect, useMemo, useState } from 'react'
import { continueRender, delayRender } from 'remotion'
import { ThemeConfig } from '../types'
import { FONTS } from './fonts'

/** Load fonts and delay render until ready. */
export default function useFonts(theme: ThemeConfig) {
  const [loaded, setLoaded] = useState(false)
  const [handle] = useState(() => delayRender())

  // const fontFamilies = useMemo(
  //   () =>
  //     compact(
  //       uniq([
  //         style.subtitle?.fontFamily,
  //         style.title?.fontFamily,
  //         style.speakerName?.fontFamily,
  //         style.speakerUsername?.fontFamily,
  //         style.transcription.fontFamily,
  //       ])
  //     ),
  //   [
  //     style.subtitle?.fontFamily,
  //     style.title?.fontFamily,
  //     style.speakerName?.fontFamily,
  //     style.speakerUsername?.fontFamily,
  //     style.transcription.fontFamily,
  //   ]
  // )
  const fontFamilies = useMemo(
    () => [theme.fonts.primary],
    [theme.fonts.primary],
  )

  useEffect(() => {
    if (!('FontFace' in window)) return

    void Promise.all(
      fontFamilies.map((family) => {
        const font = FONTS.find((font) => font.family === family)
        return font?.load().then((f: any) => {
          if (!f) return
          const meta = f.getInfo()
          const weights = Object.keys(meta.fonts.normal)
          return Promise.all(
            weights.map(async (weight) => {
              const font = new FontFace(
                f.fontFamily,
                `url(${meta.fonts.normal[weight].latin}) format('woff2')`,
                {
                  style: 'normal',
                  weight,
                  unicodeRange: meta.unicodeRanges.latin,
                },
              )

              await font.load()
              ;(document.fonts as any).add(font)
            }),
          )
        })
      }),
    ).then(() => {
      setLoaded(true)
      continueRender(handle)
    })
  }, [fontFamilies, handle])

  return loaded
}
